<template>
  <section>
    <table class="table is-striped" v-if="data && data.length">
      <thead>
        <th>Condition</th>
        <th>Status</th>
        <th></th>
      </thead>
      <tbody>
        <tr v-for="(rule, index) in data" :key="index">
          <td>
            <b-field
              :type="hasConditionError(index) ? 'is-danger' : ''"
              :message="conditionError(index)">
              <b-select
                class="is-empty"
                v-model="rule.condition.data"
                placeholder="Select one">
                <option value="" disabled>Select One</option>
                <option
                  v-for="choice in conditionChoices"
                  :value="choice.value"
                  :key="choice.value">
                  {{ choice.label }}
                </option>
              </b-select>
            </b-field>
          </td>
          <td>
              <b-select
                class="is-empty"
                v-model="rule.status.data"
                placeholder="Select one">
                <option value="" disabled>Select One</option>
                <option
                  v-for="choice in statusChoices"
                  :value="choice.value"
                  :key="choice.value">
                  {{ choice.label | humanize }}
                </option>
              </b-select>
          </td>
          <td>
            <button class="button is-primary" type="button" @click="removeRule(index)">
              <b-icon icon="minus" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="button is-primary" type="button" @click="addRule">
      <b-icon icon="plus" />
    </button>
  </section>
</template>

<script>
import CMultiSelect from '@/lib/components/MultiSelect'

export default {
  name: 'c-user-verification',
  props: ['value', 'fieldPayload', 'fieldErrors'],
  data() {
    return {
      status: this.value.prototype
        ? JSON.parse(JSON.stringify(this.value.prototype.status))
        : JSON.parse(JSON.stringify(this.value[0].status)),
    }
  },
  components: {
    CMultiSelect,
  },
  computed: {
    data() {
      return this.value || []
    },
    conditionChoices() {
      return this.fieldPayload.enabled.choices.filter(
        choice => this.fieldPayload.enabled.data.indexOf(choice.value) !== -1
      )
    },
    statusChoices() {
      try {
        return this.status.choices.slice()
      } catch (e) {
        return []
      }
    },
  },
  methods: {
    addRule() {
      const newItem = {
        status: { data: '' },
        condition: { data: '' },
      }

      if (!Array.isArray(this.data)) {
        this.$emit('input', [newItem])
      } else {
        this.value.push(newItem)
      }
    },
    removeRule(index) {
      this.value.splice(index, 1)
    },
    hasConditionError(index) {
      return Boolean(this.fieldErrors && this.fieldErrors[index] && this.fieldErrors[index].condition)
    },
    conditionError(index) {
      return this.hasConditionError(index) ? this.fieldErrors[index].condition[0].message : ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/UserVerification.vue